module.exports = __webpack_public_path__ + "img/logoArty.b9b6cf92.png";